export default __webpack_public_path__ + "static/1-0e9524495dae1a2730c02ffdfdbde6a2.jpeg";